var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchSymbol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 7 2.5 C 4.515 2.5 2.5 4.515 2.5 7 C 2.5 9.485 4.515 11.5 7 11.5 C 9.485 11.5 11.5 9.485 11.5 7 C 11.5 4.515 9.485 2.5 7 2.5 Z M 1.5 7 C 1.5 4.573 3.092 2.433 5.416 1.734 C 7.741 1.035 10.249 1.942 11.588 3.967 C 12.927 5.992 12.78 8.655 11.227 10.52 L 14.353 13.647 C 14.487 13.771 14.542 13.959 14.497 14.136 C 14.452 14.313 14.313 14.452 14.136 14.497 C 13.959 14.542 13.771 14.487 13.647 14.353 L 10.52 11.227 C 8.88 12.592 6.599 12.886 4.666 11.981 C 2.734 11.075 1.5 9.134 1.5 7 Z",
    fill: "rgb(108, 114, 132)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchSymbol);
export default __webpack_public_path__ + "static/media/searchSymbol.0a117126c07a31e2c3166c07fded0213.svg";
export { ForwardRef as ReactComponent };